// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spectrum--light .undoRedo__iconDisabled___3wghO{--iconFill:#d9d9d9}.spectrum--light .undoRedo__iconEnabled___1CPCX :hover{--iconFill:var(--spectrum-global-color-static-black)}@media (forced-colors: active){.spectrum .undoRedo__iconDisabled___3wghO,.spectrum .undoRedo__iconDisabled___3wghO svg *{--iconFill:GrayText}.spectrum .undoRedo__iconEnabled___1CPCX :hover,.spectrum .undoRedo__iconEnabled___1CPCX :hover svg *{--iconFill:ButtonText}}", ""]);
// Exports
exports.locals = {
	"iconDisabled": "undoRedo__iconDisabled___3wghO",
	"iconEnabled": "undoRedo__iconEnabled___1CPCX"
};
module.exports = exports;
